import requests from "./httpService";
import getEmployeeId from "utils/commonAdmin";

const CityVendorRequestServices = {
getAllCityVendorRequests: async (payload = {}) => {
  return requests.post(`/cityVendorRequest/`, payload);
},

  addCityVendorRequest: async (body) => {
    return requests.post(`/cityvendorrequest/add`, body);
  },

  getCityVendorRequestById: async (id) => {
    return requests.get(`/cityVendorRequest/${id}`);
  },

  updateCityVendorRequest: async (id, body) => {
    return requests.put(`/cityvendorrequest/update/${id}`, body);
  },

  deleteCityVendorRequest: async (id) => {
    return requests.delete(`/cityvendorrequest/delete/${id}`);
  },
};

export default CityVendorRequestServices;
